export default {
  ACTIVE: 'ACTIVE',
  INACTIVE: 'INACTIVE',
};
